var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checked_3_",
    "data-name": "checked (3)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 290.402,
    height: 290.402,
    viewBox: "0 0 290.402 290.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15186",
    "data-name": "Path 15186",
    d: "M199.63,74.975,103.1,171.5l-29.4-29.4a10.372,10.372,0,0,0-14.668,14.668l36.73,36.73a10.372,10.372,0,0,0,14.668,0L214.3,89.641A10.371,10.371,0,1,0,199.63,74.975Z",
    transform: "translate(8.534 10.962)",
    fill: "#51aabc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15187",
    "data-name": "Path 15187",
    d: "M145.2,0C65.137,0,0,65.137,0,145.2S65.137,290.4,145.2,290.4s145.2-65.137,145.2-145.2S225.266,0,145.2,0Zm0,269.659A124.458,124.458,0,1,1,269.659,145.2,124.6,124.6,0,0,1,145.2,269.659Z",
    fill: "#51aabc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccess);
export default __webpack_public_path__ + "static/media/payment_success.81dff4f1.svg";
export { ForwardRef as ReactComponent };